export const modalTypes = {
    SHOW_PRODUCT_DETAILS: "SHOW_PRODUCT_DETAILS",
    HIDE_PRODUCT_DETAILS: "HIDE_PRODUCT_DETAILS",

    SHOW_PROFILE: "SHOW_PROFILE",
    HIDE_PROFILE: "HIDE_PROFILE",

    SET_CATEGORY: "SET_CATEGORY",
};
